import { create } from "zustand";
import {
  LocalizationLanguage,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import i18next, { changeLanguage } from "i18next";
import { jwtDecode } from "jwt-decode";

import { PLATFORM_LANGUAGES } from "@constants";

// TODO: use enum from BE when exported
export enum CsobRegimeType {
  Open,
  Closed,
}

// TODO: create a type for JWT token data on BE and import it
export type JwtTokenData = {
  iat: number;
  csobRegimeType: CsobRegimeType | null;
  role: UserRole;
  localizationLanguage: LocalizationLanguage;
  activeCompanyId: string;
  masterCompanyId: string;
  email: string;
  passwordChangedAt: number | null;
};

type UserStore = {
  user: UserProfileDto | null;
  setUser(user?: UserProfileDto): void;
  jwtTokenData: JwtTokenData | null;
  setJwtTokenData(jwtTokenData: string): void;
};

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  jwtTokenData: null,
  setUser: (user): void => {
    if (user) {
      const localizationLanguage = user.localizationLanguage;

      if (localizationLanguage !== undefined) {
        const languageCode = PLATFORM_LANGUAGES.find(
          (lang) => lang.id === localizationLanguage,
        )?.code;
        const currentLanguage = i18next.language;

        if (languageCode !== currentLanguage) {
          changeLanguage(languageCode);
        }
      }
    }

    set(() => ({
      user,
    }));
  },
  setJwtTokenData: (jwtToken): void => {
    const data = jwtDecode<JwtTokenData>(jwtToken);

    if (data.passwordChangedAt != null && data.passwordChangedAt > data.iat * 1000) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      window.location.href = "/login";

      return;
    }

    set({ jwtTokenData: data });
  },
}));
